import {ISelectItem} from "./selectItem";

export interface IReactField {
    inputLabel: string;
    name: string;
    value: string;

    type: FIELD_TYPE;
    selectItems: ISelectItem[];

    isHidden: boolean;
    isDisabled: boolean;
    isRequired: boolean;
    maxLength: number;
    businessRuleDescription: string;
    businessRuleDescriptions: {
        type: "SIMPLE";
        description: string;
        parameters: string[];
    }[];
    fieldActions: any[];

    beforeInputRangeMinValue: any;
    beforeInputRangeMaxValue: any;

    isError: boolean;
    errorMessage: string;
}
export interface IResponseField {
    name: string;
    value: any;
    contextPath?: string;
    isProcessingOpenOnUpdate?: boolean
}

export enum FIELD_TYPE {
    FUNCTION_SELECT = 'FUNCTION_SELECT',
    DICTIONARY_SELECT = 'DICTIONARY_SELECT',
    ENUM_SELECT = 'ENUM_SELECT',
    BOOLEAN_SELECT = 'BOOLEAN_SELECT',
    INPUT_TEXT = 'INPUT_TEXT',
    INPUT_TEXT_AREA = 'INPUT_TEXT_AREA',
    INPUT_TEXT_PHONE = 'INPUT_TEXT_PHONE',
    INPUT_NUMBER = 'INPUT_NUMBER',
    INPUT_DECIMAL_NUMBER = 'INPUT_DECIMAL_NUMBER',
    DATE = 'DATE',
    DATE_TIME = 'DATE_TIME',
    CHECKBOX_MENU = 'CHECKBOX_MENU',
    AUTOCOMPLETE = 'AUTOCOMPLETE',
    ELASTIC_DICTIONARY = 'ELASTIC_DICTIONARY',
}